import { split } from 'lodash'
import { NextPage } from 'next'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import useSWR from 'swr'
import { getArticle } from '~/apis'
import Footer from '~/components/Footer'
import Header from '~/components/Header'
import { LOCALES } from '~/locales'
import { parseArticle } from '~/hooks'
import { StyledBlog } from './styled'

const Article: NextPage = () => {
  const router = useRouter()
  const asPath = router?.asPath
  const [articleId] = split(router?.query?.articleId as string, '-')
  const { t, i18n } = useTranslation()
  const isZh = i18n.resolvedLanguage === LOCALES.ZH

  const { data: dataZH } = useSWR(['getArticle', articleId, 'zh-cn'], () =>
    getArticle('zh-cn', articleId),
  )
  const { data: dataEN } = useSWR(['getArticle', articleId, 'en-us'], () =>
    getArticle('en-us', articleId),
  )
  const data = isZh ? dataZH : dataEN
  const article = parseArticle(data?.article)
  const title = dataEN?.article?.title
  const targetPath = `/blog/${encodeURIComponent(articleId + '-' + title)}`
  const desc =
    `${article?.digest.slice(0, 160)}...` ?? t('meta_blog_description')

  useEffect(() => {
    if (asPath && targetPath && asPath !== targetPath) {
      router.push(targetPath)
    }
  }, [asPath, targetPath])

  return (
    <>
      <Head>
        <title>{t('meta_blog_title')}</title>
        <meta name="description" content={desc} />
        <meta name="keywords" content={t('meta_common_keywords')} />
      </Head>
      <StyledBlog>
        <Header />
        <div className="article-page">
          <section className="content">
            <h2>{article?.title}</h2>
            <p className="updated-at">
              {t('updated_at')} {article?.updated_at}
            </p>
            <article
              className="article-body"
              dangerouslySetInnerHTML={{
                __html: article?.body,
              }}
            />
          </section>
        </div>
        <Footer />
      </StyledBlog>
    </>
  )
}

export default Article
